import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploader from "lib/mixins/uploader";
import PreparingCourseware from "components/PreparingCourseware.vue"; // import func from '../../../vue-temp/vue-editor-bridge';

export default {
  mixins: [uploader],
  props: {
    IsUpload: {
      type: Boolean,
      default: true
    },
    files: {
      type: Array,
      default: null
    },
    IsPreview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PreparingCourseware: PreparingCourseware
  },
  data: function data() {
    return {
      docId: "",
      sourceFiles: [],
      materialids: [],
      imgsList: [],
      imgUrl: "",
      indexCount: 0,
      dialogVisiblePreviewResources: false,
      fileList: [],
      isShow: false
    };
  },
  created: function created() {
    this.fileList = this.files;
  },
  watch: {
    files: {
      handler: function handler(val) {
        if (val.length > 0) {
          this.fileList = val;
        }
      },
      deep: true
    },
    fileList: function fileList(val) {
      var _this = this;

      val.forEach(function (ele) {
        _this.materialids.push(ele.id);
      });
    }
  },
  methods: {
    dialogClose: function dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    uploadFile: function uploadFile() {},
    fileLimit: function fileLimit() {
      this.$message.warning("一次最多上传8个文件");
    },
    beforeUpload: function beforeUpload(file) {
      console.log(this.fileList);
      var ext = file.name.split(".").pop();
      return ["jpg", "jpeg", "png", "gif", "doc", "docx", "txt", "xls", "xlsx", "pdf"].includes(ext) && this.addFile(file);
    },
    onRemoveHandler: function onRemoveHandler(file) {
      var index = this.materialids.indexOf(file.id);
      this.materialids.splice(index, 1);
      this.$emit("done", this.materialids);
    },
    beforeRemove: function beforeRemove(file, fileList) {
      var that = this;
      this.$http.post("/api/XOrg/SpecialActivity/deleteFile", {
        docId: file.docId
      }).then(function (rst) {});
    },
    handlePreview: function handlePreview(file) {
      if (this.IsPreview) {
        this.dialogVisiblePreviewResources = true;
        this.docId = file.id;
      }
    },
    onSuccessHandler: function onSuccessHandler(res, file, uploadFiles) {
      var that = this;
      this.$http.post("/api/XOrg/SpecialActivity/uploadFile", {
        docId: res.docId,
        docPath: res.docPath,
        fileName: file.name
      }).then(function (rst) {});
      this.IsShowUpload = false; // 执行mixins里的onSuccess, 继续下一个文件

      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles); // uploadFiles.forEach(val => {
        //   this.fileList.push({
        //     name:val.name,
        //     url:val.url
        //   });
        // });
      }

      if (res.code > 0) {
        file.url = res.docPath;
      }

      this.materialids.push(res.docId);
      this.$emit("done", this.materialids);
    }
  }
};